import InboxChat from "./InboxChat";
export default InboxChat;